import React, { Component } from 'react';

interface IProps {
    children: JSX.Element;
    renderErrElement?(errs: IErrInfo[]): JSX.Element;
    onError?(err: IErrInfo): void;
}

interface IState {
    hasError: boolean;
    errorStore: IErrInfo[];
}

interface IErrInfo {
    msg: string;
    stack: string;
}

/**
 * 组件异常捕获
 */
export class ErrorBoundary extends Component<IProps, IState> {
    public static getDerivedStateFromError() {
        return { hasError: true};
    }

    constructor(props: IProps) {
        super(props);
        this.state = {
            hasError: false,
            errorStore: [],
        };
        // this.initSentry();
    }

    public initSentry() {
        if (!Sentry) {
            return;
        }
        const option = {
            dsn: 'http://abc9a36a5d964c6bae19d390435e5a00@172.24.200.90:9000/2',
            integrations: [
                new Sentry.Integrations.BrowserTracing(),
                new Sentry.Integrations.GlobalHandlers({
                //   onunhandledrejection: true,
                  onerror: true,
                }),
            ],
            sampleRate: 0.3,
            tracesSampleRate: 0.3,
            attachStacktrace: 'on',
        };
        Sentry.init(option);
    }

    public componentDidCatch(msg: Error, errInfo: {componentStack: string}) {
        const { onError } = this.props;
        const err = {
            msg: String(msg),
            stack: errInfo.componentStack,
        };
        this.setState({
            errorStore: [...this.state.errorStore, err],
        });
        if (typeof onError === 'function') {
            onError(err);
        }
    }

    public renderErrs() {
        const errors = [...this.state.errorStore];
        errors.reverse();
        return errors.map((err) => {
            return <pre>{JSON.stringify(err)}</pre>;
        });
    }

    public renderErrMsg() {
        const { hasError } = this.state;
        if (hasError) {
            return this.props.renderErrElement ?
                this.props.renderErrElement(this.state.errorStore) :
                this.renderErrs();
        }
        return null;
    }

    public render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        return this.renderErrMsg();
    }
}
